import React from 'react'
import './UnleashPotential.scss'
import OrangeButton from './OrangeButton'
import FiveStars from '../Images/5stars.svg'



function UnleashPotential() {
  const handleBtnClick = () => {
    const contactPopup = document.querySelector('.contact-popup');
    if (contactPopup) {
      if (contactPopup.classList.contains('contact-popup-active')) {
        contactPopup.classList.remove('contact-popup-active');
      }
      else {
        contactPopup.classList.add('contact-popup-active');
      }
    }
  };

  return (
    <div className='unleash-potential-main full-width'>
      <div className='content main-grid'>

      </div>
      <h3 className='unbounded-font'>Unleash your business potential <br />
        with us and go beyond.</h3>

      <div className='button-div'>
        <div className='send-btn' onClick={handleBtnClick}>
          <OrangeButton
            text='Let’s Talk'
          />
        </div>
      </div>

      <p className='inter-font'>Join our satisfied clients and go beyond with us.</p>

      <div className='stars-section'>
        <div className='col-one'>
          <img src={FiveStars} alt='Five Stars' />

          <p >
            “Many years of our cooperation bear fruit <br />
            very good results of my company.”
          </p>

        </div>
        <div className='col-two'>
          <img src={FiveStars} alt='Five Stars' />

          <p>
            “Effectively coordinatedand<br />
            professional team"
          </p>

        </div>
        <div className='col-three'>
          <img src={FiveStars} alt='Five Stars' />

          <p>
            “High level of service helps me grow<br />
            the company on a scale of 20-30% per year”
          </p>




        </div>
      </div>
    </div>
  )
}

export default UnleashPotential